import type { DriveStep } from "driver.js";

export const DEPARTURES_TOUR_STEPS: DriveStep[] = [
  {
    element: '[data-tour="departures-day-picker"]',
    popover: {
      title: "Tag wählen",
      description:
        "Filtern Sie Abreisen nach Tag – heute und die nächsten Tage. Die Zähler zeigen ausstehende Abreisen pro Tag.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="departures-table"]',
    popover: {
      title: "Abreiseliste",
      description:
        "Eingecheckte Gäste mit geplanter Abreise. Offene Rechnungsbeträge werden in der Tabelle angezeigt.",
      side: "top",
      align: "start",
    },
  },
  {
    element: '[data-tour="departures-actions"]',
    popover: {
      title: "Check-out",
      description:
        "Über „Auschecken“ schließen Sie den Aufenthalt ab: Schlüsselrückgabe, Rechnungsprüfung und ggf. Rechnungsentwurf. Je nach Einstellung ist eine bezahlte Rechnung Voraussetzung.",
      side: "left",
      align: "center",
    },
  },
];
